import { ExemptionType } from "models/ExemptionType";
import { ExemptionTypeData } from "models/types";
import { BaseServices } from "./baseServices";

export class ExemptionTypeService extends BaseServices<ExemptionTypeData, ExemptionType> {
	constructor() {
		super(ExemptionType);
	}

	async listByConcessionaire(concessionaireId: string) {
		return this.list(`exemption-type/${concessionaireId}`);
	}

	static getInstance() {
		return new ExemptionTypeService();
	}
}
